import React from 'react';
import { Grid } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';
import { DetailsSectionInfoWrapper } from 'app/main/components/page-layouts';
import { type DetailsPageContentProps } from 'app/main/components/page-layouts/details/DetailsPage';
import DetailsSectionNotes from 'app/main/submodules/notes/DetailsSectionNotes';
import DetailsSectionBilling from 'app/main/modules/components/DetailsSectionBilling';
import DetailsSectionShipping from 'app/main/modules/components/DetailsSectionShipping';

import ErpQuotationsDetailsSectionInfo from '../sections/ErpQuotationsDetailsSectionInfo';
import ErpQuotationsDetailsSectionSecondaryInfo from '../sections/ErpQuotationsDetailsSectionSecondaryInfo';

export default function ErpQuotationsDetailsTab(props: DetailsPageContentProps) {
	const { t } = useSettings();

	return (
		<Grid container spacing={2}>
			<Grid size={{ lg: 8, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="text-subject" />}
							title={t('DETAILS_INFO_SECTION')}
							subheader={t('DETAILS_INFO_SUBHEADER')}
						>
							<ErpQuotationsDetailsSectionInfo
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="text-subject" />}
							title={t('DETAILS_SECONDARY_INFO_SECTION')}
							subheader={t('DETAILS_SECONDARY_INFO_SUBHEADER')}
						>
							<ErpQuotationsDetailsSectionSecondaryInfo
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					<Grid size={12}>
						<DetailsSectionNotes module="erp_quotations" uid={props.model.ords_uid} />
					</Grid>
				</Grid>
			</Grid>
			<Grid size={{ lg: 4, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="credit-card" />}
							title={t('DETAILS_BILLING_COMPANY_SECTION')}
							subheader={t('DETAILS_BILLING_COMPANY_SUBHEADER')}
						>
							<DetailsSectionBilling
								module="erp_quotations"
								model={props.model}
								isEdit={props.isEdit}
								sendChange={props.sendChange}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="truck" />}
							title={t('DETAILS_SHIPPING_ADDRESS_SECTION')}
							subheader={t('DETAILS_SHIPPING_ADDRESS_SUBHEADER')}
						>
							<DetailsSectionShipping
								module="erp_quotations"
								model={props.model}
								isEdit={props.isEdit}
								sendChange={props.sendChange}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}
